import { EntryType } from '../../../models/entry-type';
import { Key } from '../../../models/key';
import { KeyType } from '../models/key';

export function resolveEntryTypeFromKey(key: string): EntryType | null {
  switch (new Key(key).type) {
    case KeyType.AbEntry:
    case KeyType.Company:
    case KeyType.Contact:
    case KeyType.Individual:
      return 'addressBook';
    case KeyType.Lead:
      return 'lead';
    case KeyType.Opportunity:
      return 'opportunity';
    case KeyType.CSCase:
      return 'case';
    case KeyType.Campaign:
      return 'campaign';
    default:
      return null;
  }
}
